var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wl-matter-log-add-edit-container" }, [
    _c(
      "div",
      { staticClass: "wl-matter-log-add-edit-btns" },
      [
        _vm.data.user.userType == "1"
          ? _c(
              "el-button",
              {
                staticClass: "wl-green",
                attrs: { loading: _vm.saveLoading, type: "primary" },
                on: { click: _vm.onConfirm },
              },
              [_vm._v(_vm._s(_vm.$t("btn_save")) + "\n    ")]
            )
          : _vm._e(),
        _c(
          "el-button",
          { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
          [_vm._v(_vm._s(_vm.$t("comment_reSet")) + "\n    ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "formCenter" },
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            staticClass: "wl-form",
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              "label-width": "200px",
            },
          },
          [
            _c(
              "el-row",
              { staticClass: "row-bg", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("TABLE_HEADER_matter"),
                          prop: "title",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "wl-form-item input-with-select",
                          attrs: {
                            disabled: _vm.data.user.userType == "2",
                            maxlength: "50",
                          },
                          model: {
                            value: _vm.ruleForm.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "title", $$v)
                            },
                            expression: "ruleForm.title",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("TABLE_HEADER_category_placeholder"),
                          prop: "category",
                        },
                      },
                      [
                        _c("select-multi", {
                          staticClass: "wl-form-item",
                          attrs: {
                            disabled:
                              !_vm.data.isNew && _vm.data.user.userType == "2",
                            api: _vm.selectCategory,
                            onChanage: _vm.onCategoryChange,
                            filterable: true,
                          },
                          model: {
                            value: _vm.ruleForm.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "category", $$v)
                            },
                            expression: "ruleForm.category",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("FORM_LABEL_matterType"),
                          prop: "matterType",
                        },
                      },
                      [
                        _c("select-multi", {
                          staticClass: "wl-form-item",
                          attrs: {
                            disabled:
                              !_vm.data.isNew && _vm.data.user.userType == "2",
                            api: _vm.selectMatter,
                            onChanage: _vm.onMatterTypeChange,
                          },
                          model: {
                            value: _vm.ruleForm.matterType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "matterType", $$v)
                            },
                            expression: "ruleForm.matterType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "row-bg", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("FORM_LABEL_Organization"),
                          prop: "organization",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "wl-form-item input-with-select",
                            attrs: {
                              multiple: "",
                              "collapse-tags": "",
                              clearable: "",
                              filterable: "",
                            },
                            on: { onChanage: _vm.onOrganizationChange },
                            model: {
                              value: _vm.ruleForm.organization,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "organization", $$v)
                              },
                              expression: "ruleForm.organization",
                            },
                          },
                          _vm._l(_vm.organizationList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.entityName, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("FORM_LABEL_kpmgOwner"),
                          prop: "kpmgOwner",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "wl-form-item input-with-select",
                            attrs: {
                              disabled:
                                !_vm.data.isNew &&
                                _vm.data.user.userType == "2",
                              filterable: "",
                            },
                            on: { onChanage: _vm.onKPMGOwnerChange },
                            model: {
                              value: _vm.ruleForm.kpmgOwner,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "kpmgOwner", $$v)
                              },
                              expression: "ruleForm.kpmgOwner",
                            },
                          },
                          _vm._l(_vm.kpmgOwnerList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label:
                                  item.userName +
                                  " ( " +
                                  item.profitCenter +
                                  " ) ",
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("FORM_LABEL_clientOwner"),
                          prop: "clientOwner",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "wl-form-item input-with-select",
                            attrs: {
                              disabled:
                                !_vm.data.isNew &&
                                _vm.data.user.userType == "2",
                              filterable: "",
                            },
                            on: { onChanage: _vm.onClientOwnerChange },
                            model: {
                              value: _vm.ruleForm.clientOwner,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "clientOwner", $$v)
                              },
                              expression: "ruleForm.clientOwner",
                            },
                          },
                          _vm._l(_vm.clientOwnerList, function (item) {
                            return _c("el-option", {
                              key: item.userId,
                              attrs: {
                                label: item.userName,
                                value: item.userId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "row-bg", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("TABLE_HEADER_Issues"),
                          prop: "status",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "wl-form-item input-with-select",
                            attrs: {
                              disabled:
                                !_vm.data.isNew &&
                                _vm.data.user.userType == "2",
                              filterable: "",
                            },
                            on: { onChanage: _vm.onStatusChange },
                            model: {
                              value: _vm.ruleForm.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "status", $$v)
                              },
                              expression: "ruleForm.status",
                            },
                          },
                          _vm._l(_vm.statusList, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: {
                                label: _vm.$t(item.label),
                                value: item.value,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("FORM_LABEL_priority"),
                          prop: "priority",
                        },
                      },
                      [
                        _c("select-multi", {
                          staticClass: "wl-form-item wl-form-item",
                          attrs: {
                            disabled:
                              !_vm.data.isNew && _vm.data.user.userType == "2",
                            api: _vm.selectPriority,
                            onChanage: _vm.onPriorityChange,
                          },
                          model: {
                            value: _vm.ruleForm.priority,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "priority", $$v)
                            },
                            expression: "ruleForm.priority",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "row-bg", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("TABLE_HEADER_Description_placeholder"),
                          prop: "description",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "input-with-select",
                          staticStyle: { width: "80%" },
                          attrs: {
                            type: "textarea",
                            maxlength: "1000",
                            "show-word-limit": "",
                            disabled:
                              !_vm.data.isNew && _vm.data.user.userType == "2",
                            rows: 7,
                          },
                          model: {
                            value: _vm.ruleForm.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "description", $$v)
                            },
                            expression: "ruleForm.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }